<template>
    <div class="onboarding" v-if="!hidden">
      <b-container class="contentcontainer" :class="(currentStep === 1) ? 'active' : ''">
        <b-row class="contentcontainer__head">
          <b-col>
            <h2>👋 Welcome to Backupmonkey</h2>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col>
            <p>First of all: Thank you very much for choosing BackupMonkey. We're super happy to have you here. Now that you are here, we would like to introduce you to BackupMonkey, the tool to maintain all your CMS-Installations in one place.</p>
            <p>At the moment, there are no Installations connected to our service. <strong>Time to add your first site!</strong></p>
          </b-col>
        </b-row>
        <b-row align-h="end" class="contentcontainer__footer">
          <b-col cols="auto">
            <button class="onboarding__steptoggler btn btn--primary" @click="nextStep()">Add my first site</button>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="contentcontainer" :class="(currentStep === 2) ? 'active' : ''">
        <b-row class="contentcontainer__head">
          <b-col>
            <h2>Download Remotemonkey</h2>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col>
            <p>You will see that connecting a website to our service is super easy.</p>
            <p>First you have to <a href="http://download.backupmonkey.io/rbm/pkg_remotemonkey.zip">download our RemoteMonkey Component.</a></p>
          </b-col>
        </b-row>
        <b-row align-h="end" class="contentcontainer__footer">
          <b-col cols="auto">
            <button class="onboarding__steptoggler btn btn--primary" @click="nextStep()">Next</button>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="contentcontainer" :class="(currentStep === 3) ? 'active' : ''">
        <b-row class="contentcontainer__head">
          <b-col>
            <h2>Install Remotemonkey</h2>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col>
            <p>After downloading our RemoteMonkey you have to install the RemoteMonkey on the Joomla!-Site you would like to connect to your BackupMonkey-Profile.</p>
            <p>If you don’t have any clue how to install an extension just look in the <a href="https://docs.joomla.org/Installing_an_extension" target="_blank">Joomla documentation</a>.</p>
          </b-col>
        </b-row>
        <b-row align-h="end" class="contentcontainer__footer">
          <b-col cols="auto">
            <button class="onboarding__steptoggler btn btn--primary" @click="nextStep()">Next</button>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="contentcontainer" :class="(currentStep === 4) ? 'active' : ''">
        <b-row class="contentcontainer__head">
          <b-col>
            <h2>Connect your Site</h2>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col>
            <p>You’re nearly done. Just hit the „connect“-Button in your backend after installing the RemoteMonkey.</p>
            <p>The site will automatically be added to your account if you're allready logged in. Otherwise a Tab will open asking you to login into your BackupMonkey-Account.</p>
          </b-col>
        </b-row>
        <b-row align-h="end" class="contentcontainer__footer">
          <b-col cols="auto">
            <button class="onboarding__steptoggler btn btn--primary" @click="nextStep()">Finish</button>
          </b-col>
        </b-row>
      </b-container>
      <b-container class="contentcontainer" :class="(currentStep === 5) ? 'active' : ''">
        <b-row class="contentcontainer__head">
          <b-col>
            <h2>🔥 Hell yeah!</h2>
          </b-col>
        </b-row>
        <hr/>
        <b-row>
          <b-col>
            <p><strong>🎉 Congratulations.</strong> You just added your first site to BackupMonkey. You now have full control over extension, backups and the Joomla-Core. </p>
            <p>Save time using BackupMonkey and grab yourself a Banana. 🍌</p>
          </b-col>
        </b-row>
        <b-row align-h="end" class="contentcontainer__footer">
          <b-col cols="auto">
            <button class="onboarding__steptoggler btn btn--primary"  @click="hidden = true">Close</button>
          </b-col>
        </b-row>
      </b-container>
    </div>
</template>

<script>
export default {
  name: 'Onboarding',

  data () {
    return {
      currentStep: 1,
      hidden: false
    }
  },

  methods: {
    nextStep () {
      this.currentStep += 1
    }
  }
}
</script>
